
import {
  useGetFupPoliciesQuery,
  useBatchUpdateFupMutation,
  useDeletePolicyMutation,
  useBulkDeletePolicyMutation,
} from '../../baseApi';

// =======================
// List hook (server-driven pagination + filters)
// =======================
export const useFupList = (args = {}) => {
  const {
    pageNumber = 1,
    pageSize = 25,
    searchColumn,
    searchValue,
    fromFupDate,
    toFupDate,
    sortField,
    sortOrder,
    fetchAll,
  } = args;

  const payload = {
    pageNumber,
    pageSize,
    searchColumn,
    searchValue,
    fromFupDate,
    toFupDate,
    sortField,
    sortOrder,
    fetchAll: pageSize === 0 ? true : fetchAll,
  };

  return useGetFupPoliciesQuery(payload);
};

// =======================
// Operations wrapper (batch update + delete)
// =======================
export const useFupOperations = () => {
  const [batchUpdateFup, batchMeta] = useBatchUpdateFupMutation();
  const [deletePolicy, deleteMeta] = useDeletePolicyMutation();
  const [bulkDeletePolicy, bulkDeleteMeta] = useBulkDeletePolicyMutation();

  return {
    batchUpdateFup,  // call: await batchUpdateFup({ ids, newFupDate, updatedBy })
    deletePolicy,    // call: await deletePolicy(policyId)
    bulkDeletePolicy, // call: await bulkDeletePolicy({ ids: [...] })
    meta: {
      batchUpdateFup: batchMeta,
      deletePolicy: deleteMeta,
      bulkDeletePolicy: bulkDeleteMeta,
    },
    isProcessing: batchMeta.isLoading || deleteMeta.isLoading || bulkDeleteMeta.isLoading,
  };
};
